import ScreenLoading from 'components/ScreenLoading'
import React, { useEffect, useState } from 'react'
import { NavigationBookmark } from 'types'

const BookmarkNavigationMenu = ({
  report,
  bookmarks,
  fetchingBookmark,
  handleGoToReportBookmark,
}) => {
  const [hoveredBookmark, setHoveredBookmark] = useState(null)
  // const [reportNavBookmarks, setReportNavBookmarks] = useState<
  //   NavigationBookmark[]
  // >([])

  // useEffect(() => {
  //   if (bookmarks && bookmarks.length > 0) {
  //     const filteredBookmarks = bookmarks.filter(
  //       (bookmark: NavigationBookmark) =>
  //         !bookmark.reports ||
  //         bookmark.reports.length === 0 ||
  //         bookmark.reports.some((r) => r.slug === report.slug)
  //     )
  //     setReportNavBookmarks(filteredBookmarks)
  //   }
  //   return () => {
  //     setHoveredBookmark(null)
  //   }
  // }, [])

  // return reportNavBookmarks?.length > 0 ? (
  return bookmarks?.length > 0 ? (
    <>
      <div
        key={report.slug}
        className="bookmark-menu"
        onClick={(e) => e.stopPropagation()}
      >
        <ul>
          {bookmarks?.length > 0 ? (
            bookmarks?.sort((a: NavigationBookmark, b: NavigationBookmark) => Math.max(a.order, 0) - Math.max(b.order, 0)).map((bookmark: NavigationBookmark) => (
              <NavItem
                key={bookmark.id}
                report={report}
                bookmark={bookmark}
                hoveredBookmark={hoveredBookmark}
                setHoveredBookmark={setHoveredBookmark}
                handleGoToReportBookmark={handleGoToReportBookmark}
              />
            ))
          ) : fetchingBookmark ? (
            <ScreenLoading />
          ) : (
            <p className="">No bookmarks</p>
          )}
        </ul>
      </div>
    </>
  ) : (
    <></>
  )
}

const NavItem = ({
  handleGoToReportBookmark,
  bookmark,
  report,
  hoveredBookmark,
  setHoveredBookmark,
}) => {
  useEffect(() => {
    // handle click outside of the report list
    const handleClickOutside = (e) => {
      if (!e.target.closest('.bookmark-item')) {
        setHoveredBookmark(null)
      }
    }
    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  return (
    <li
      className={`bookmark-item ${bookmark?.is_category ? 'category' : ''}`}
      key={bookmark.id}
      data-bookmarkid={bookmark.id}
      onMouseOver={(e) => {
        e.stopPropagation()
        e.preventDefault()
        setHoveredBookmark(bookmark.id)
      }}
      onMouseEnter={(e) => {
        e.stopPropagation()
        e.preventDefault()
        setHoveredBookmark(bookmark.id)
      }}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        if (!bookmark?.is_category)
          handleGoToReportBookmark(report.slug, bookmark)
      }}
    >
      <p>{bookmark.name}</p>
      {bookmark?.show_demo && <span className="demo">Demo</span>}
      {bookmark?.children && bookmark?.children?.length > 0 && (
        <>
          <span className="material-icons-outlined">keyboard_arrow_right</span>
          {hoveredBookmark === bookmark.id && (
            <BookmarkNavigationMenu
              bookmarks={bookmark?.children}
              fetchingBookmark={false}
              handleGoToReportBookmark={handleGoToReportBookmark}
              report={report}
              key={bookmark.id}
            />
          )}
        </>
      )}
    </li>
  )
}
export default React.memo(BookmarkNavigationMenu)
